import i18next from "i18next";
import moment from "moment-timezone";

export const moneyFormatter = (n: number): string => {
    if (n < 1000) return n.toString();
    if (n >= 1000 && n < 1000000) return +(n / 1000) + " K";
    if (n >= 1000000 && n < 1000000000) return +(n / 1000000) + " M";
    if (n >= 1000000000 && n < 1000000000000) return +(n / 1000000000) + " B";
    if (n >= 1000000000000) return +(n / 1000000000000) + " T";
    return n.toString()
}

export const showDateExpired = (startDate: string, endDate: string): string => {
    const now = moment()
    if(moment(endDate, "YYYY-MM-DD").isBefore(now)) {
        return '<p class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-700 ring-red-600/10 dark:ext-red-400 dark:bg-red-400/20">Expired</p>'
    } else if(moment(startDate, "YYYY-MM-DD").isBefore(now)) {
        const diff = moment(endDate, "YYYY-MM-DD").diff(now, 'days')
        return '<p class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-green-50 text-green-700 ring-green-600/20 dark:bg-green-500/10 dark:text-green-400">' + (diff > 1 ? `${diff} days` : `${diff} day`) + '</p>'
    }
    return '<span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-yellow-600/20 ring-inset">Will Rent</span>'
}

export const showStatusRental = (status: number, startDate: string, endDate: string): string => {
    const now = moment()
    if(status === 1) {
        return `<p class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-700 ring-red-600/10 dark:ext-red-400 dark:bg-red-400/20">${i18next.t("rental.expired")}</p>`
    } else if(status === 2) {
        const diff = moment(endDate, "YYYY-MM-DD").diff(now, 'months') + 1
        return '<p class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-green-50 text-green-700 ring-green-600/20 dark:bg-green-500/10 dark:text-green-400">' + (diff > 1 ? `left ${diff} months` : `left ${diff} month`) + '</p>'
    } else if(status === 3) {
        return '<p class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-blue-400 ring-blue-600/20 bg-blue-500/10 text-blue-400">' + i18next.t("rental.type_renew") + '</p>'
    }
    return `<span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-yellow-600/20 ring-inset">${i18next.t("rental.will_rent")}</span>`
}

export const classNameExpiredRental = (status: number, endDate: string): string => {
    let className = ''
    const now = moment()
    if(status === 2) {
        const diff = moment(endDate, "YYYY-MM-DD").diff(now, 'months') + 1
        if(diff <= 1) {
            className = 'bg-danger dark:bg-danger'
        } else if(diff <= 2) {
            className = 'bg-warning dark:bg-warning'
        } else if(diff <= 3) {
            className = 'bg-yellow-300 dark:bg-yellow-400'
        } else {
            className = 'bg-green-400 dark:bg-green-500'
        }
    }
    return className
}

export const classNameTenantFinExpiry = (strFinExpiry: string): string => {
    let className = ''
    if(strFinExpiry) {
        const finExpiry = moment(strFinExpiry, "YYYY-MM-DD").startOf('month')
        const now = moment().startOf('month')
        const diff = finExpiry.diff(now, 'months') + 1
        if(diff === 1) {
            className = 'bg-danger dark:bg-danger'
        } else if(diff === 2) {
            className = 'bg-warning dark:bg-warning'
        } else if(diff === 3) {
            className = 'bg-yellow-300 dark:bg-yellow-400'
        }
    }
    return className
}
